import * as React from 'react';
import { DashboardContainer } from 'components/Dashboard';
import { fetchOrganizationIfNeeded } from '@pec/aion-ui-core/actions/organization';
import { Loading } from '@pec/aion-ui-components/components/Loading';
import { NewDashboardContainer } from './NewDashboard/NewDashboardContainer';
import { OrganizationFeature } from '@pec/aion-ui-core/interfaces/organization';
import { useAppDispatch, useTypedSelector } from '../combineReducers';
import { useParams } from 'react-router-dom';

const { NewDashboard } = OrganizationFeature;

export const MainPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const { organizationId } = useParams<{ organizationId: string }>();
  const { organization, isFetching } = useTypedSelector(state => state.organization);
  const hasNewDashboardFeature = organization?.features.includes(NewDashboard);

  React.useEffect(() => {
    organizationId && dispatch(fetchOrganizationIfNeeded(organizationId));
  }, [dispatch, organizationId]);

  if (isFetching) {
    return <Loading />;
  }

  if (hasNewDashboardFeature) {
    return <NewDashboardContainer />;
  }

  return <DashboardContainer />;
};
